import { useEffect, useContext, useMemo } from 'react'
import { Paper, Skeleton, Typography } from '@mui/material'
import RoleContext from '../auth/RoleContext'
import { ApiGateway, FeatureFlags } from '../config/config'
import FileListControl from '../form/FileListControl'
import { Stack } from '@mui/system'
import { LetterTypes, WorkflowStatuses } from './common'

export default function AuthorizationFilesCard(props = {}) {
  const roleDetails = useContext(RoleContext)

  const { authorization, readOnly, noTable } = props

  useEffect(() => {
    
  }, [authorization])

  const visibilityFlags = useMemo(() => {
      const hasParent = authorization?.parentId ? true : false
      const isDraft = authorization.workflowStatus === WorkflowStatuses.DRAFT
      const isPublished = authorization.workflowStatus === WorkflowStatuses.PUBLISHED
      const isHistorical = authorization.isHistorical
      return {
        hasParent,
        isDraft,
        isPublished,
        isHistorical
      }
    }, [authorization])
  
  const {
    hasParent,
    isDraft,
    isPublished,
    isHistorical
  } = visibilityFlags

  const isAdminUser = roleDetails.isAdminUser()
  const isAuthorizationEditor = roleDetails.isQualityManager() || roleDetails.isSupplyChainManager()

  const authorizationEditable = !readOnly && ((isAuthorizationEditor && isDraft && isHistorical) || isAdminUser)
  const supportingFilesEditable = !readOnly && isAuthorizationEditor
  
  return (
        <Paper elevation={1} sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', width: '100%', padding: "5px" }}>
          <Stack rowGap={1}>
            {!(isDraft && !isHistorical) && <>
              <Typography fontWeight='bold' variant="body" color="text.secondary">Latest authorization letter</Typography>
              
              {props.loading && <Skeleton />}
              {!props.loading && authorization?.id && <FileListControl
                listFilesUrl={`${ApiGateway.authorizations}/${authorization.id}/files`}
                showLastModified={true}
                showActions={authorizationEditable}
                enableUpload={authorizationEditable}
                enableDownload={true}
                getFileUrlServiceAddr={`${ApiGateway.authorizations}/${authorization.id}/files/`}
                getPutFileUrlServiceAddr={`${ApiGateway.authorizations}/${authorization.id}/files/new-file-url`}
                removeFileUrl={`${ApiGateway.authorizations}/${authorization.id}/files`}
                altFileNameColumnLabel='Original File Name'
                noTable={noTable}
              />}
              {!props.loading && !authorization?.id && 
                <Typography variant="body" color="text.secondary">No authorization letter found</Typography>
              }
              </>}

              <Typography fontWeight='bold' variant="body" color="text.secondary">Supporting Files</Typography>
              {props.loading && <Skeleton />}
              {!props.loading && authorization?.id && <FileListControl
                listFilesUrl={`${ApiGateway.authorizations}/${authorization.id}/supporting/files`}
                showLastModified={true}
                showActions={supportingFilesEditable}
                enableUpload={supportingFilesEditable}
                enableDownload={true}
                getFileUrlServiceAddr={`${ApiGateway.authorizations}/${authorization.id}/supporting/files/`}
                getPutFileUrlServiceAddr={`${ApiGateway.authorizations}/${authorization.id}/supporting/files/new-file-url`}
                removeFileUrl={`${ApiGateway.authorizations}/${authorization.id}/supporting/files`}
                noTable={noTable}
              />}

              {!props.loading && isDraft && (hasParent && authorization.letterType !== LetterTypes.NEW) &&
              (
                <>
                <Typography fontWeight='bold' variant="body" color="text.secondary">Supporting Files from Published Version</Typography>
                {props.loading && <Skeleton />}
                {!props.loading && authorization?.id && <FileListControl
                  listFilesUrl={`${ApiGateway.authorizations}/${authorization.parentId}/supporting/files`}
                  showLastModified={true}
                  showActions={false}
                  enableUpload={false}
                  enableDownload={true}
                  getFileUrlServiceAddr={`${ApiGateway.authorizations}/${authorization.parentId}/supporting/files/`}
                  noTable={noTable}
                />}
                </>
              )
              }

          </Stack>
        </Paper>
  )
}